import React, { useEffect, useRef, useState } from "react";
import { recentVotes } from "@/api";
import { AX_HOME as HOME } from "@/constants/testIds";

const POLL_MS = 30_000;
const FEED_SIZE = 5;

const scoreTone = (s) => {
  if (s >= 66) return "var(--ax-accent)";
  if (s >= 33) return "var(--ax-warn)";
  return "var(--ax-danger)";
};

const relTime = (iso) => {
  try {
    const t = new Date(iso).getTime();
    const diff = Math.max(0, (Date.now() - t) / 1000);
    if (diff < 60) return `${Math.floor(diff)}s`;
    if (diff < 3600) return `${Math.floor(diff / 60)}m`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
    return `${Math.floor(diff / 86400)}d`;
  } catch {
    return "—";
  }
};

const LiveIntelFeed = () => {
  const [votes, setVotes] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const timer = useRef(null);
  const newestKey = useRef(null);

  const fetchOnce = async () => {
    try {
      const data = await recentVotes(FEED_SIZE);
      setVotes(data);
      setLoaded(true);
      if (data.length) newestKey.current = data[0].voted_at + data[0].codename;
    } catch {
      setLoaded(true);
    }
  };

  useEffect(() => {
    fetchOnce();
    timer.current = setInterval(fetchOnce, POLL_MS);
    return () => clearInterval(timer.current);
  }, []);

  if (!loaded) return null; // Don't flash a header before first response

  return (
    <div data-testid={HOME.intelFeed} className="intel-feed fade-in">
      <div className="intel-feed-header">
        <span className="intel-stamp">
          {"┌─[ LIVE INTEL FEED ]"}<span className="cursor" />
        </span>
        <span className="intel-meta">
          {votes.length === 0 ? "AWAITING SIGNAL" : `${votes.length} INTERCEPTS`}
          {" · POLL 30s"}
        </span>
      </div>
      <div className="intel-feed-body" role="log" aria-live="polite">
        {votes.length === 0 && (
          <div className="intel-row faint">
            $ no votes yet. be the first to rate a dossier.
          </div>
        )}
        {votes.map((v, i) => {
          const key = `${v.voted_at}-${v.codename}-${v.theory_slug}`;
          return (
            <div
              key={key}
              data-testid={HOME.intelFeedItem(i)}
              className="intel-row"
              style={{ animationDelay: `${i * 35}ms` }}
            >
              <span className="intel-time">{`[${relTime(v.voted_at)}]`}</span>
              {" "}
              <span className="intel-codename">{`[${v.codename}]`}</span>
              {" "}
              <span className="intel-muted">rated</span>
              {" "}
              <span className="intel-title">{`[${v.theory_title}]`}</span>
              {" "}
              <span className="intel-muted">credibility:</span>
              {" "}
              <span
                className="intel-score"
                style={{ color: scoreTone(v.score) }}
              >
                {v.score}/100
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LiveIntelFeed;
